/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import IconComponent from 'ui/src/components/Icon';
import twMerge from 'utilities/src/twMerge';
import MobileMenu from './MobileMenu';

import useHeader from '../header/hooks/useHeader';
import { MobileMenuProps } from './_props';

function MobileHeader({ menuItems }: MobileMenuProps) {
  const { isMobileMenuOpen, toggleMobileMenu, toggleMobileMenuActiveItem, hasScrolled, bgHeader } = useHeader();

  const handleMenuClick = () => {
    toggleMobileMenu();
    if (isMobileMenuOpen) {
      toggleMobileMenuActiveItem('');
    }
  };

  return (
    <>
      <button
        type="button"
        className="mdL:hidden block"
        onClick={handleMenuClick}
        aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isMobileMenuOpen}
      >
        <IconComponent
          iconName={isMobileMenuOpen ? 'Close' : 'Menu'}
          size="IconM"
          className={twMerge(
            bgHeader !== 'Transparent' || hasScrolled ? 'bg-site-neutrals-900' : 'bg-site-neutrals-0',
          )}
        />
      </button>

      <MobileMenu menuItems={menuItems} />
    </>
  );
}

export default MobileHeader;
